import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FileSaverService {
  constructor() {}

  async saveFile(data: Blob, fileName: string) {
    // Dynamic import, load only when needed
    const { default: saveAs } = await import('file-saver');
    saveAs(data, fileName);
  }
}
